import {SchemaProps} from "./JsonLdSchemaRouter";
import {
    context,
    currency,
    pictureUri,
    product,
    productDescription,
    productName,
    productPrice,
    type_product
} from "./JsonLdUtil";
import {normalizeCanonicalUrl} from "../headUtils";

export function getProductSchema(props: SchemaProps) {
    const rawUrl = props?.page?.canonicalUrl ?? '';
    const url = rawUrl ? normalizeCanonicalUrl(rawUrl) : rawUrl;
    return {
        "@context": context,
        "@id": url + product,
        "@type": type_product,
        "description": productDescription(props),
        "name": productName(props),
        "image": pictureUri(props),
        "url": url,
        "offers": {
            "@type": "Offer",
            "price": productPrice(props),
            "availability": "https://schema.org/InStock",
            "priceCurrency": currency
        },
    };
}
